export default "__VITE_ASSET__DrxcZbc6__"